import { LuBomb, LuCigarette, LuCrosshair, LuFlame, LuLockKeyhole, LuTreePine } from 'react-icons/lu';

import { RestrictionType } from '@ndvr/portfolio-api';

export const restrictionTypeMap = {
    [RestrictionType.DO_NOT_BUY]: 'Do Not Buy',
    [RestrictionType.DO_NOT_SELL]: 'Do Not Sell',
    [RestrictionType.DO_NOT_BUY_OR_SELL]: 'Do Not Buy or Sell',
    [RestrictionType.LAST_TO_SELL]: 'Last To Sell',
    [RestrictionType.INSIDER]: 'Insider',
};

export const categoryIconMap = {
    DEFORESTATION: LuTreePine,
    FOSSIL: LuFlame,
    GUN: LuCrosshair,
    PRISON: LuLockKeyhole,
    TOBACCO: LuCigarette,
    WEAPONS: LuBomb,
} as const;
